import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import DashboardLayout from "@/pages/DashboardLayout";
import DashboardHome from "@/pages/DashboardHome";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import UploadLeads from "@/pages/UploadLeads";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import InviteAccept from "@/pages/InviteAccept";
import Analytics from "@/pages/Analytics";
import Sequences from "@/pages/Sequences";
import DomainScraper from "@/pages/DomainScraper";
import EnrichCSV from "@/pages/EnrichCSV";
import LookalikeSearch from "@/pages/LookalikeSearch";
import TriggerEvents from "@/pages/TriggerEvents";
import AdminDashboard from "@/pages/AdminDashboard";
import CRMPipeline from "@/pages/CRMPipeline";
import { Toaster } from "@/components/ui/sonner";


function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-gray-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/pricing" element={<Pricing />} />
        <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/invite/:token" element={<InviteAccept />} />
            <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
              <Route index element={<DashboardHome />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="crm" element={<CRMPipeline />} />
              <Route path="campaigns/:id" element={<CampaignDetail />} />
              <Route path="leads" element={<Leads />} />
              <Route path="leads/:id" element={<LeadDetail />} />
              <Route path="upload" element={<UploadLeads />} />
              <Route path="team" element={<Team />} />
              <Route path="billing" element={<Billing />} />
              <Route path="settings" element={<Settings />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="sequences" element={<Sequences />} />
              <Route path="scraper" element={<DomainScraper />} />
              <Route path="enrich" element={<EnrichCSV />} />
              <Route path="lookalikes" element={<LookalikeSearch />} />
              <Route path="triggers" element={<TriggerEvents />} />
              <Route path="admin" element={<AdminDashboard />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
